import ButtonElement, { ColorButton } from '@/views/elements/button/ButtonElement';
import { Stack } from '@mui/system';
import { ReactNode } from 'react';

interface UserActionsProps {
    actions: Array<{
        appendIcon?: ReactNode; 
        prependIcon?: ReactNode;
        label: string;
        onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
        disabled?: boolean;
        color?: ColorButton;
    }>
}

const UserActions = ({ actions }: UserActionsProps) => {
    return (
        <Stack spacing='20px' sx={{ width: "100%", marginTop: '0 !important' }} direction={"row"}>
            {actions.map((action, index) => (
                <ButtonElement
                    key={index}
                    className={action.disabled ? 'fake-disabled' : ''}
                    customType={action.color ? action.color : 'Primary'}
                    sx={{ 
                        display: 'flex', alignItems: 'center',
                        fontSize: '14px', lineHeight: '21px'
                    }}
                    onClick={action.disabled ? () => {} : action.onClick}
                >
                    {action.prependIcon}
                    {action.label}
                    {action.appendIcon}
                </ButtonElement>
            ))}
        </Stack>
    );
};

export default UserActions;